module.exports = __webpack_public_path__ + "img/ActForex-white.d236b6ef.png";